module.exports = __webpack_public_path__ + "static/media/boat-img-38.122c1a31.jpg";